<script setup>
const emit = defineEmits(['zoom', 'save', 'print', 'contact'])

const handleZoom = () => {
  emit('zoom')
}

const handleSave = () => {
  emit('save')
}

const handlePrint = () => {
  emit('print')
}

const handleContact = () => {
  emit('contact')
}
</script>

<template>
  <div class="flex relative top-0 w-full h-9 bg-window-white border-top-grey overflow-hidden">
    <div class="flex items-center h-full min-w-max">
      <!-- Zoom Button -->
      <div
        @click="handleZoom"
        class="rounded-sm border hover:border-gray-300 hover:shadow-header-tools flex items-center h-8 px-1 md:px-0.5 ml-0.5 cursor-pointer"
      >
        <img src="/img/icons/windows-header-tools/magnifier-icon.webp" alt="Zoom" class="w-5 h-5 flex-shrink-0" />
        <p class="hidden md:block small-p ml-1 mr-0.5">Zoom</p>
      </div>
      
      <!-- Save Button -->
      <div
        @click="handleSave"
        class="rounded-sm border hover:border-gray-300 hover:shadow-header-tools flex items-center h-8 px-1 md:px-0.5 ml-0.5 cursor-pointer"
      >
        <img src="/img/icons/windows-header-tools/folder-opening-icon.webp" alt="Save" class="w-6 h-6 flex-shrink-0" />
        <p class="hidden md:block small-p ml-1 mr-0.5">Save</p>
      </div>
      
      <!-- Print Button -->
      <div
        @click="handlePrint"
        class="rounded-sm border hover:border-gray-300 hover:shadow-header-tools flex items-center h-8 px-1 md:px-0.5 ml-0.5 cursor-pointer"
      >
        <img src="/img/icons/windows-header-tools/folder-open-icon.webp" alt="Print" class="w-6 h-6 flex-shrink-0" />
        <p class="hidden md:block small-p ml-1 mr-0.5">Print</p>
      </div>
      
      <!-- Contact Me Button -->
      <div
        @click="handleContact"
        class="rounded-sm border hover:border-gray-300 hover:shadow-header-tools flex items-center h-8 px-1 md:px-0.5 ml-0.5 cursor-pointer"
      >
        <img src="/img/icons/contact/email-icon-sm.webp" alt="Contact Me" class="w-5 h-5 flex-shrink-0" />
        <p class="hidden md:block small-p ml-1 mr-0.5">Contact Me</p>
      </div>
    </div>
  </div>
</template>

